import React from 'react';
import styles from '../../style/Common.module.css';

const GradientLine = () => {
  return (
    <span className={styles.gradientLine}></span>
  )
}

export default GradientLine
